import type { GlobalApiAccountAccess } from '@data/account-access';
import type { GlobalApiPaymentDetails } from '@data/global-api-payments';

import { getFlow } from './getFlow/getFlow';

export const getViewKey = (
  payload: GlobalApiAccountAccess | GlobalApiPaymentDetails | null | undefined
): string | null => {
  if (!payload) return null;

  const flow = getFlow(payload);

  if (!flow) {
    return null;
  }

  if ('requiredInput' in flow) {
    return flow.requiredInput?.map((input) => input.name).join('-');
  }

  if ('details' in flow) {
    return flow.details?.reason ?? null;
  }

  return null;
};
